import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {ModuleVisibility} from '../../../../data/model/moduleVisibility';
import {SignedRequest} from '../../../../data/model/signedRequest';
import {ModulesDataManager} from '../../../../data/modules.datamanager';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component(
    {selector: 'edit-module-dialog', templateUrl: './edit-module-dialog.html'})
export class EditModuleDialogComponent {
  statusText = 'starting upload';
  name = '';
  isExam = false;
  value = 0;
  showProgress = false;
  module: File = null;
  image: File = null;
  nameInput = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<EditModuleDialogComponent>,
      private uploadDataManager: UploadDataManager,
      private modulesDataManager: ModulesDataManager,
      @Inject(MAT_DIALOG_DATA) public data: any) {}

  getErrorMessage() {
    // return this.amountInput.hasError('required') ? 'You must enter an amount'
    // :
    '';
  }
  onAddClick(data) {
    if (this.image === null && this.module === null) {
      this.modulesDataManager.updateModule(this.data.module)
          .subscribe(
              (res) => {
                this.closeDialogSuccess('Succesfully updated the module');
              },
              (err) => {
                console.log(err);
                this.closeDialogWithError(err.json());
              });
    }
    else if (this.image !== null && this.module === null){
      this.statusText = 'Uploading image';
      this.showProgress = true;
      this.value = 0;
      this.uploadDataManager.getSignedUpload(this.image.name, this.image.type)
          .subscribe(
              (imageSignedResponse) => {
                this.uploadDataManager
                    .uploadFileToS3(imageSignedResponse, this.image)
                    .subscribe(
                        (imageResponse) => {
                          if (typeof imageResponse === 'string') {
                            this.data.module.image_url = imageSignedResponse.url;
                            this.modulesDataManager
                                .updateModule(this.data.module)
                                .subscribe(
                                    (res) => {
                                      this.closeDialogSuccess(
                                          'succesfully updated the organisation');
                                    },
                                    (err) => {
                                      console.log(err);
                                      this.closeDialogWithError(err.json());
                                    });
                          }
                            else {
                              this.value = imageResponse;
                            }
                          },
                          (err) => {
                            console.log(err);
                            this.closeDialogWithError(err.json());
                          });
                },
                (err) => {
                  console.log(err);
                  this.closeDialogWithError(err.json());
                });
    }
    else if (this.image === null && this.module !== null){
      this.statusText = 'Uploading module';
      this.showProgress = true;
      this.value = 0;
      this.uploadDataManager.getSignedUpload(this.module.name, this.module.type)
      .subscribe(
          (moduleSignedResponse) => {
            this.uploadDataManager
                .uploadFileToS3(moduleSignedResponse, this.module)
                .subscribe(
                    (moduleResponse) => {
                      if (typeof moduleResponse === 'string') {
                        this.data.module.tincan_url = moduleSignedResponse.url;
                        this.modulesDataManager
                            .updateModule(this.data.module)
                            .subscribe(
                                (res) => {
                                  this.closeDialogSuccess(
                                      'succesfully updated the organisation');
                                },
                                (err) => {
                                  console.log(err);
                                  this.closeDialogWithError(err.json());
                                });
                      } else {
                        this.value = moduleResponse;
                      }
                    },
                    (err) => {
                      console.log(err);
                      this.closeDialogWithError(err.json());
                    });
          },
          (err) => {
            console.log(err);
            this.closeDialogWithError(err.json());
          });
    }
    else if (this.image !== null && this.module !== null) {
      this.statusText = 'Uploading image';
      this.showProgress = true;
      this.value = 0;
      this.uploadDataManager.getSignedUpload(this.image.name, this.image.type)
          .subscribe(
              (imageSignedResponse) => {
                this.uploadDataManager
                    .uploadFileToS3(imageSignedResponse, this.image)
                    .subscribe(
                        (imageResponse) => {
                          if (typeof imageResponse === 'string') {
                            this.uploadDataManager.getSignedUpload(this.module.name, this.module.type)
                            .subscribe(
                                (moduleSignedResponse) => {
                                  this.value = 0;
                                  this.statusText = 'Uploading module';
                                  this.uploadDataManager
                                      .uploadFileToS3(moduleSignedResponse, this.module)
                                      .subscribe(
                                          (moduleResponse) => {
                                            if (typeof moduleResponse === 'string') {
                                              this.data.module.image_url = imageSignedResponse.url;
                                              this.data.module.tincan_url = moduleSignedResponse.url;
                                              this.modulesDataManager
                                                  .updateModule(this.data.module)
                                                  .subscribe(
                                                      (res) => {
                                                        this.closeDialogSuccess(
                                                            'succesfully updated the organisation');
                                                      },
                                                      (err) => {
                                                        console.log(err);
                                                        this.closeDialogWithError(err.json());
                                                      });
                                            } else {
                                              this.value = moduleResponse;
                                            }
                                          },
                                          (err) => {
                                            console.log(err);
                                            this.closeDialogWithError(err.json());
                                          });
                                },
                                (err) => {
                                  console.log(err);
                                  this.closeDialogWithError(err.json());
                                });
                          } else {
                            this.value = imageResponse;
                          }
                        },
                        (err) => {
                          console.log(err);
                          this.closeDialogWithError(err.json());
                        });
              },
              (err) => {
                console.log(err);
                this.closeDialogWithError(err.json());
              });
    }
  }

  handleImageInput(files: FileList) {
    this.image = files.item(0);
  }

  openImageUpload() {
    document.getElementById('image-id').click();
  }

  handleModuleInput(files: FileList) {
    this.module = files.item(0);
  }
  openModuleUpload() {
    document.getElementById('module-id').click();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  closeDialogSuccess(message: string) {
    this.dialogRef.close(message);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/edit/edit.module.dialog.component.ts